import React from 'react';
import styles from 'routes/adminMobile/components/AdminMobileOrderStorePhoneNo.module.css';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import { mainBgColor, mainPadd2, pageCommonGap1, pageEH2FontSize, pageEH3FontSize, registerGap2, statDetailFontColor } from '../constraints/AdminConst';
import AdminMobileEmptyMsg from './common/AdminMobileEmptyMsg';
import AdminMobileContentBox from './common/AdminMobileContentBox';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';
import callBtn from 'routes/adminMobile/images/callbtn.png';

const AdminMobileOrderStorePhoneNo = ({orderData}) => {
    // orderData 존재하지 않는 경우에 대한 예외 처리
    if (!orderData) {
        return (
            <VerticalFlex>
                <FlexChild padding={mainPadd2}>
                    <AdminMobileEmptyMsg />
                </FlexChild>
            </VerticalFlex>
        );
    }
    

    // 전화 걸기 버튼 클릭 이벤트 핸들러
    const handleCallButtonClick = () => {
        // 전화 걸기 기능 구현
        window.location.href = `tel:${orderData.storePhoneNumber}`;
    };

    return (
        <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={mainPadd2}>
            <FlexChild>
                <AdminMobileContentBox>
                    <HorizontalFlex>
                        <FlexChild>
                            <VerticalFlex gap={registerGap2}>
                                <FlexChild alignItems="flex-start">
                                    <P size={pageEH3FontSize} color={statDetailFontColor}>배달 매장</P>
                                </FlexChild>
                                <FlexChild alignItems="flex-start">
                                    <P size={pageEH2FontSize}>
                                        대전 {orderData.storeName ? orderData.storeName : "매장명 없음"}
                                    </P>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild width="auto">
                            {/* 전화걸기 버튼 */}
                            <div className={styles.callBtn} onClick={handleCallButtonClick}>
                                <img className={styles.callIcon} src={callBtn} alt='전화 걸기 버튼' />
                            </div>
                        </FlexChild>
                    </HorizontalFlex>
                </AdminMobileContentBox>
            </FlexChild>
        </VerticalFlex>
    );
};

export default AdminMobileOrderStorePhoneNo;